import axios from "axios"
import { setToken, refreshToken } from '../interceptors/jwt-interceptor'
import '../interceptors/loader-interceptor'
import '../interceptors/internal-server-interceptor'


const apiUrl = process.env.GATASBY_API_URL;

export const generateAccessTokenFromRefresh = (data) => {
    if (typeof window === "undefined") {
        return
    }
    return new Promise((resolve, reject) => {
        axios
            .post(`${apiUrl}/generate-accessToken-from-refeshToken`, data)
            .then(res => {
                if (res.data?.accessToken) {
                    setToken(res.data)
                    resolve(res)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

// pnb redirect url
export const perfiosGenerateLink = (data) => {
    if (typeof window === "undefined") {
        return;
    }

    return new Promise((resolve, reject) => {
        axios
            .post(`${apiUrl}/perfios-generate-link`, data)
            .then((res) => {
                if (res && res.data) {
                    resolve(res?.data)
                }
            })
            .catch(error => {
                if ([403].includes(error?.response?.status)) {
                    let payload = {
                        refreshToken: refreshToken
                    }
                    generateAccessTokenFromRefresh(payload)
                        .then(res => {
                            perfiosGenerateLink(data)
                                .then(res => {
                                    console.log(res, "sdff")
                                    if (res && res.data) {
                                        resolve(res)
                                    }
                                })
                                .catch(error => {
                                    reject(error)
                                })
                        })
                        .catch(error => {
                            reject(error)
                        })
                } else {
                    reject(error)
                }
            })
    })

}